import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as AssetUtils from '../../../../utils/asset';
import * as ItemUtils from '../../utils';
//  Taken from elements.jsx
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
/**
 * Outputs asset for a DisplayItem.
 *
 * @namespace
 * @memberOf Common.Components.DisplayItems.Elements
 *
 * @prop item : {object} display item
 */
class ItemAsset extends React.Component {
  constructor(props) {
    super(props);
  }

  handleRef(name) {
    this[`set${name}`] = domEle => (this[name] = domEle);
    return this[`set${name}`];
  }

  render() {
    const { thumbnail, contentType, assetClasses, link, id, shouldAutoPlay, item, itemOpts, styles } = this.props;
    const isVideoOrGif = AssetUtils.isVideoOrGif(contentType);
    const isMuted = true;
    // Add a conditional class so it can be targeted in the MediaLayer
    return (
      <div className={assetClasses} ref={this.handleRef('asset')}>
        <Choose>
          <When condition={shouldAutoPlay && isVideoOrGif}>
            {ItemUtils.getVideoComponent({ item, itemOpts, shouldAutoPlay, isMuted, styles })}
          </When>
          <When condition={isVideoOrGif && !thumbnail && !shouldAutoPlay}>
            {ItemUtils.getVideoComponent({ item, itemOpts, isMuted, styles })}
          </When>
          <Otherwise>
            <img
              src={thumbnail}
              className="xThumbnail"
              alt={
                _.get(item, 'content.content') ||
                _.get(item, 'content.caption') ||
                _.get(item, 'content.heading') ||
                'Content Image'
              }
            />
            <If condition={isVideoOrGif}>
              <i key={id} className="xIcon xIconPlay" />
            </If>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

ItemAsset.propTypes = {
  // We could pass down the displayAssets OR a string allowing us to dynamically choose a thumbnail size
  thumbnail:    PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  contentType:  PropTypes.string,
  assetClasses: PropTypes.string,
  id:           PropTypes.string,
};

export default ItemAsset;
